module.exports = "/assets/data/191fef36ca9e33541447d7025d6e65b8-SK8.data.json";